import * as React from 'react';
import { FC } from 'react';
import Box from '@mui/material/Box';

/**
 * A React component that renders a header element containing a styled box.
 * The box is positioned fixed at the top of the page, and has centered content with some margin.
 */
export const Header: FC = () => {
  return (
    <header>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 10,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          '& > *': {
            m: 1,
          },
        }}
      ></Box>
    </header>
  );
};
